import { Box, Container, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { theme } from "./theme";
import useTranslationState from "./useTranslationState";

function RentalChefs() {
    const navigate = useNavigate();

    const translations = useTranslationState({
        rentalChefs: '',
        rentalChefBigText: '',
        backToServices: 'Back to Services',
    });

    return (
        <>
            {/* Hero Section */}
            <Box
                sx={{
                    width: '100%',
                    height: { xs: '50vh', md: '60vh' },
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'linear-gradient(180deg, rgba(66,79,82,0.3) 0%, rgba(66,79,82,0.9) 90%)',
                            zIndex: 2,
                        },
                    }}
                >
                    <Box
                        component="img"
                        src="https://picsum.photos/id/431/2400/1200"
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center 35%',
                            filter: 'brightness(0.9)',
                            animation: 'slowZoom 30s infinite alternate ease-in-out',
                            '@keyframes slowZoom': {
                                '0%': { transform: 'scale(1)' },
                                '100%': { transform: 'scale(1.1)' }
                            }
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        position: 'relative',
                        zIndex: 3,
                        textAlign: 'center',
                        px: 3,
                        maxWidth: '900px',
                        opacity: 0,
                        animation: 'fadeInUp 1s forwards cubic-bezier(0.23, 1, 0.32, 1)',
                        '@keyframes fadeInUp': {
                            '0%': {
                                opacity: 0,
                                transform: 'translateY(30px)',
                            },
                            '100%': {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                        },
                    }}
                >
                    <Typography
                        variant="h2"
                        component="h1"
                        sx={{
                            fontWeight: 600,
                            color: 'white',
                            letterSpacing: '-0.02em',
                            mb: 2,
                            textShadow: '0px 2px 4px rgba(0,0,0,0.15)',
                            fontSize: { xs: '2.5rem', md: '3.5rem' },
                        }}
                    >
                        {translations.rentalChefs}
                    </Typography>
                    <Box
                        sx={{
                            width: '80px',
                            height: '3px',
                            background: theme.palette.primary.main,
                            mx: 'auto',
                            mb: 4,
                            borderRadius: '2px',
                        }}
                    />
                </Box>
            </Box>

            {/* Content Section */}
            <Box
                sx={{
                    width: '100%',
                    background: `linear-gradient(to bottom, ${theme.palette.primary.dark} 0%, #374447 100%)`,
                    py: { xs: 8, md: 12 },
                    color: 'white',
                }}
            >
                <Container maxWidth="md">
                    <Box
                        sx={{
                            opacity: 0,
                            animation: 'fadeIn 0.8s forwards cubic-bezier(0.23, 1, 0.32, 1)',
                            animationDelay: '0.4s',
                            '@keyframes fadeIn': {
                                '0%': {
                                    opacity: 0,
                                    transform: 'translateY(10px)',
                                },
                                '100%': {
                                    opacity: 1,
                                    transform: 'translateY(0)',
                                },
                            },
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                mb: 6,
                                lineHeight: 1.8,
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '1.1rem',
                                maxWidth: '700px',
                                mx: 'auto',
                                position: 'relative',
                                '&::before': {
                                    content: '""',
                                    fontFamily: 'Georgia, serif',
                                    fontSize: '4rem',
                                    color: theme.palette.primary.main,
                                    opacity: 0.5,
                                    position: 'absolute',
                                    top: '-1.5rem',
                                    left: '-2rem',
                                },
                            }}
                        >
                            {translations.rentalChefBigText}
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 6,
                            }}
                        >
                            <Button
                                onClick={() => navigate("/")}
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    borderRadius: '8px',
                                    padding: '12px 28px',
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    borderColor: 'rgba(255,255,255,0.3)',
                                    color: 'white',
                                    boxShadow: 'none',
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                        borderColor: 'white',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                        transform: 'translateY(-3px)',
                                        backgroundColor: 'rgba(255,255,255,0.08)',
                                    }
                                }}
                            >
                                {translations.backToServices}
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    );
}

export default RentalChefs; 
